export enum UserTypes {
  OWNER = 'owner',
  ORG_USER = 'organization_user',
  ORG_OWNER = 'organization_owner',
  FINAL_USER = 'final_user',
  FINAL_OWNER = 'final_owner',
  EMPLOYEE = 'employee',
  SUPER_ADMIN = 'super_admin',
  MANAGER = 'manager',
  ADMIN = 'admin',
  ASSISTANT_MANAGER = 'assistant',
  CASHIER = 'cashier',
  RESELLER = 'reseller',
}

export const FINAL_USERS = [UserTypes.FINAL_USER, UserTypes.FINAL_OWNER];

export const ORG_USERS = [UserTypes.ORG_USER, UserTypes.ORG_OWNER];

export const COMPANY_USERS = [
  UserTypes.OWNER,
  UserTypes.ADMIN,
  UserTypes.MANAGER,
  UserTypes.ASSISTANT_MANAGER,
  UserTypes.CASHIER,
];

export const CDK_USER_TYPES = [
  UserTypes.ORG_USER,
  UserTypes.ORG_OWNER,
  UserTypes.FINAL_USER,
  UserTypes.FINAL_OWNER,
  UserTypes.SUPER_ADMIN,
];
